import { FC } from 'react';
import LoanApplicationProcessLayout from 'ui/components/LoanApplicationProcessLayout';
import WelcomeBack from './WelcomeBack';

const WelcomeBackScene: FC = () => {
  return (
    <LoanApplicationProcessLayout>
      <WelcomeBack />
    </LoanApplicationProcessLayout>
  );
};

export default WelcomeBackScene;
